var _style, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158.4 158.4",
    style: {
      enableBackground: "new 0 0 158.4 158.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D71F26;}\n\t.st1{fill:#383838;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#383938;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{fill:#010101;}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{opacity:0.48;}\n\t.st16{fill:url(#SVGID_12_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.33,110.56h-3.05v2.52h-1.44v2.79h1.44v3.27c0,2.57,2.08,4.2,4.65,4.2h1.8v-2.67h-1.81 c-0.88,0-1.59-0.71-1.59-1.59v-3.21l2-0.01c0.78-0.03,1.4-0.67,1.4-1.46v-1.32h-3.39V110.56z M66.81,119.2 c0,0.87-0.71,1.59-1.6,1.59c-0.88,0-1.58-0.72-1.58-1.59v-4.65c0-0.81-0.65-1.47-1.47-1.47h-1.59v5.72 c0,2.57,1.39,4.66,4.64,4.66c3.26,0,4.65-2.09,4.65-4.66v-5.72h-3.05V119.2 M80.37,118.52c-0.02-3.18-1.75-5.68-4.96-5.68 c-2.76,0-4.98,2.23-4.98,5.3c0,3.31,2.02,5.27,5,5.33c1.94,0,3.63-1.09,4.49-2.69l-2.79-0.73c-0.34,0.51-0.98,0.86-1.73,0.86 c-1.09,0-1.97-0.78-2-1.73h6.95C80.38,119.04,80.37,118.68,80.37,118.52 M73.42,117.1c0.03-0.95,0.91-1.72,2-1.72 c1.1,0,1.99,0.76,2,1.72H73.42z M58.08,113.08h-0.05h-0.36c-2.33,0-4.23,1.89-4.23,4.23v6.03h3.05v-5.88 c0-0.88,0.71-1.59,1.6-1.59h1.78v-2.79h-1.14H58.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.37,110.49v12.88h-2.33v-12.88H86.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.11,117.3c0.03,0.19,0.05,0.39,0.07,0.59c0.02,0.2,0.03,0.42,0.03,0.65v0.34h-6.68 c0.03,0.22,0.06,0.44,0.1,0.66c0.04,0.22,0.1,0.44,0.19,0.66c0.14,0.33,0.36,0.62,0.65,0.88c0.29,0.25,0.7,0.38,1.22,0.38 c0.52,0,0.93-0.13,1.22-0.38c0.29-0.25,0.51-0.55,0.65-0.88h2.48c-0.1,0.45-0.25,0.83-0.43,1.16c-0.18,0.33-0.39,0.62-0.61,0.86 c-0.22,0.24-0.46,0.44-0.72,0.6c-0.25,0.16-0.5,0.29-0.74,0.39c-0.59,0.23-1.2,0.34-1.85,0.34c-0.85-0.01-1.61-0.19-2.27-0.53 c-0.28-0.15-0.56-0.35-0.83-0.58c-0.27-0.24-0.52-0.53-0.72-0.89c-0.21-0.36-0.38-0.78-0.51-1.28c-0.13-0.5-0.19-1.07-0.19-1.74 c0-0.66,0.06-1.24,0.19-1.74c0.13-0.5,0.3-0.93,0.51-1.29c0.21-0.36,0.45-0.66,0.72-0.91c0.27-0.24,0.55-0.44,0.83-0.59 c0.66-0.36,1.42-0.55,2.27-0.57c0.7,0.03,1.35,0.17,1.96,0.44c0.25,0.11,0.51,0.26,0.77,0.45c0.26,0.18,0.5,0.41,0.73,0.69 c0.22,0.27,0.42,0.6,0.59,0.97C95.91,116.37,96.03,116.8,96.11,117.3z M93.71,117.3c-0.06-0.2-0.14-0.41-0.24-0.61 c-0.1-0.2-0.23-0.39-0.39-0.55c-0.17-0.17-0.36-0.3-0.59-0.39c-0.23-0.1-0.5-0.14-0.8-0.14c-0.31,0-0.57,0.05-0.8,0.14 c-0.23,0.1-0.43,0.23-0.59,0.39c-0.17,0.17-0.3,0.35-0.4,0.55c-0.1,0.2-0.18,0.41-0.23,0.61H93.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.36,117.51c0.17,0,0.41,0,0.71,0.01c0.3,0.01,0.62,0.03,0.97,0.08c0.34,0.04,0.69,0.12,1.04,0.23 c0.35,0.11,0.67,0.26,0.95,0.47c0.28,0.2,0.51,0.46,0.69,0.78c0.18,0.32,0.27,0.71,0.27,1.18c0,0.74-0.16,1.33-0.47,1.76 c-0.31,0.44-0.7,0.77-1.15,1c-0.45,0.23-0.94,0.37-1.46,0.44c-0.52,0.06-0.99,0.1-1.39,0.1c-0.07,0-0.23,0-0.48-0.01 c-0.25-0.01-0.53-0.04-0.86-0.1c-0.33-0.06-0.67-0.17-1.03-0.31c-0.36-0.14-0.69-0.34-1-0.6c-0.3-0.26-0.55-0.6-0.75-1.01 c-0.2-0.41-0.29-0.94-0.29-1.54h2.25c0,0.11,0.02,0.27,0.06,0.43c0.04,0.16,0.12,0.31,0.26,0.47c0.14,0.15,0.34,0.28,0.61,0.39 c0.27,0.11,0.66,0.2,1.12,0.22c0.58,0.01,1-0.05,1.32-0.11c0.31-0.06,0.56-0.14,0.7-0.24c0.15-0.11,0.22-0.23,0.26-0.35 c0.03-0.11,0.05-0.22,0.05-0.32c0-0.11-0.01-0.23-0.06-0.34c-0.03-0.08-0.13-0.22-0.29-0.31c-0.15-0.1-0.39-0.17-0.72-0.24 c-0.33-0.06-0.78-0.1-1.35-0.11c-0.44-0.01-0.88-0.08-1.33-0.19c-0.44-0.11-0.84-0.29-1.2-0.52c-0.36-0.24-0.64-0.53-0.87-0.89 c-0.22-0.36-0.33-0.78-0.33-1.26c0-0.53,0.11-1,0.33-1.4c0.22-0.4,0.51-0.73,0.88-0.98c0.36-0.25,0.78-0.44,1.24-0.57 c0.47-0.13,0.96-0.19,1.47-0.19c0.27,0,0.63,0.03,1.09,0.1c0.45,0.06,0.9,0.21,1.34,0.44c0.44,0.23,0.81,0.57,1.12,1.01 c0.31,0.45,0.46,1.05,0.45,1.81h-2.25c0-0.41-0.13-0.73-0.4-0.96c-0.26-0.24-0.73-0.38-1.41-0.38c-0.5,0-0.91,0.13-1.22,0.32 c-0.31,0.2-0.46,0.47-0.46,0.81c0,0.33,0.15,0.57,0.44,0.71C110.51,117.44,110.9,117.51,111.36,117.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119,113.7v9.67h-2.33v-9.67H119z M119.01,110.7h-2.34v2.1h2.34V110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124,113.45c0.04,0,0.17,0.01,0.41,0.02c0.24,0.01,0.51,0.07,0.83,0.16c0.32,0.1,0.65,0.24,1.01,0.45 c0.36,0.2,0.69,0.5,0.99,0.88c0.31,0.38,0.56,0.86,0.75,1.44c0.2,0.58,0.3,1.29,0.3,2.15v4.83h-2.33v-4.83 c0-0.28-0.03-0.57-0.08-0.86c-0.05-0.29-0.15-0.56-0.29-0.8c-0.14-0.24-0.34-0.44-0.59-0.6c-0.25-0.16-0.59-0.24-1.01-0.24 c-0.42,0-0.76,0.08-1.01,0.24c-0.25,0.16-0.45,0.36-0.59,0.6c-0.14,0.24-0.24,0.51-0.29,0.8c-0.05,0.29-0.08,0.58-0.08,0.86 v4.83h-2.33v-4.83c0-0.85,0.1-1.57,0.3-2.15c0.2-0.58,0.45-1.06,0.75-1.44c0.31-0.38,0.64-0.67,0.99-0.88 c0.36-0.2,0.69-0.35,1.01-0.45c0.32-0.1,0.59-0.15,0.82-0.16C123.81,113.45,123.95,113.45,124,113.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.64,116.39c-0.17-0.63-0.43-1.16-0.79-1.6c-0.36-0.44-0.82-0.77-1.38-1c-0.56-0.23-1.24-0.34-2.04-0.34 c-0.85,0.03-1.61,0.22-2.27,0.57c-0.28,0.15-0.56,0.35-0.83,0.59c-0.27,0.24-0.52,0.54-0.73,0.91 c-0.21,0.36-0.38,0.79-0.51,1.29c-0.13,0.5-0.19,1.07-0.19,1.74c0,0.66,0.06,1.24,0.18,1.74c0.12,0.5,0.28,0.92,0.48,1.28 c0.2,0.36,0.42,0.65,0.67,0.89c0.25,0.24,0.51,0.43,0.77,0.58c0.61,0.34,1.31,0.52,2.1,0.53c0.39-0.03,0.78-0.11,1.14-0.25 c0.32-0.13,0.64-0.33,0.97-0.61c0.14-0.12,0.28-0.27,0.4-0.44v1.03c0,0.14-0.02,0.34-0.05,0.59c-0.03,0.25-0.15,0.51-0.36,0.75 c-0.21,0.25-0.54,0.46-1,0.64c-0.46,0.18-1.12,0.27-1.98,0.27h-2.06v2.16l2.54,0.02c0.72,0,1.37-0.07,1.93-0.21 c0.56-0.14,1.04-0.34,1.45-0.59c0.41-0.25,0.74-0.56,1-0.91c0.26-0.35,0.45-0.73,0.56-1.15c0.08-0.28,0.14-0.58,0.18-0.91 c0.04-0.32,0.07-0.68,0.07-1.06v-4.35C137.88,117.74,137.8,117.02,137.64,116.39z M135.22,120.38 c-0.16,0.29-0.38,0.52-0.67,0.72s-0.66,0.29-1.14,0.29c-0.47,0-0.85-0.1-1.14-0.29c-0.29-0.19-0.51-0.43-0.66-0.72 c-0.15-0.29-0.25-0.59-0.31-0.93c-0.05-0.33-0.08-0.64-0.08-0.92c0-0.28,0.03-0.58,0.08-0.92c0.05-0.33,0.15-0.64,0.31-0.93 c0.15-0.29,0.37-0.52,0.66-0.72c0.29-0.19,0.66-0.29,1.14-0.29c0.5,0,0.89,0.08,1.18,0.25c0.29,0.17,0.51,0.38,0.66,0.66 c0.15,0.27,0.24,0.58,0.29,0.92c0.04,0.34,0.07,0.68,0.07,1.02c0,0.28-0.03,0.59-0.08,0.92 C135.49,119.79,135.38,120.1,135.22,120.38z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.41,113.69h2.13v9.69h-2.13v-1.4c-0.8,1.06-1.89,1.57-2.94,1.57c-1.33,0-2.42-0.48-3.29-1.44 c-0.86-0.98-1.29-2.2-1.29-3.66c0-1.44,0.43-2.63,1.29-3.59c0.86-0.96,1.94-1.41,3.23-1.44c1.14-0.02,2.14,0.24,3,1.04V113.69z  M98.89,118.35c0,0.92,0.24,1.67,0.72,2.24c0.49,0.58,1.11,0.88,1.86,0.88c0.8,0,1.44-0.28,1.93-0.85 c0.49-0.58,0.74-1.32,0.74-2.22c0-0.9-0.25-1.64-0.74-2.22c-0.49-0.57-1.13-0.86-1.92-0.86c-0.74,0-1.36,0.29-1.86,0.87 C99.14,116.77,98.89,117.49,98.89,118.35z"
  })))))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.64,78.81c-0.08,0-0.35-0.01-0.83-0.04c-0.48-0.02-1.03-0.13-1.68-0.32c-0.64-0.19-1.32-0.48-2.04-0.88 c-0.72-0.4-1.39-0.97-2.01-1.72c-0.62-0.75-1.13-1.69-1.52-2.83c-0.4-1.14-0.6-2.54-0.6-4.22l-0.01-9.38l4.7,0l0.01,10.04 c0,0.55,0.05,1.11,0.16,1.69c0.1,0.58,0.3,1.1,0.58,1.58c0.28,0.48,0.68,0.87,1.2,1.18c0.51,0.31,1.19,0.47,2.04,0.47 c0.85,0,1.53-0.16,2.04-0.47c0.51-0.31,0.91-0.71,1.19-1.18c0.28-0.48,0.47-1,0.58-1.58c0.1-0.58,0.15-1.14,0.15-1.69L81.59,59.4 l4.7,0l0.01,9.38c0,1.68-0.2,3.08-0.59,4.22c-0.4,1.14-0.9,2.08-1.52,2.83c-0.62,0.75-1.28,1.33-2,1.73 c-0.72,0.4-1.4,0.7-2.04,0.88c-0.64,0.19-1.2,0.29-1.68,0.32C78,78.79,77.72,78.81,77.64,78.81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.08,63.86l0.01,8.37c0.08,0.3,0.22,0.58,0.42,0.83c0.18,0.2,0.43,0.39,0.75,0.56 c0.32,0.17,0.74,0.26,1.25,0.26l2.93,0l0,4.54l-4.7,0c-1-0.1-1.9-0.37-2.7-0.82c-0.67-0.37-1.28-0.93-1.83-1.67 c-0.55-0.74-0.83-1.76-0.83-3.06l-0.02-18.57l4.7,0l0.01,5.1l4.43,0l0,4.47L95.08,63.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.1418,
    y1: 91.1707,
    x2: 54.1418,
    y2: 39.2706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.62,59.96h4.34v19.19h-4.34v-2.77c-1.41,2.12-3.85,3.11-5.99,3.11c-2.7,0-4.92-0.95-6.69-2.85 c-1.75-1.94-2.62-4.35-2.62-7.25c0-2.85,0.87-5.22,2.62-7.12c1.75-1.9,3.94-2.8,6.57-2.85c2.32-0.04,4.35,0.48,6.11,2.06V59.96z  M48.4,69.22c0,1.79,0.49,3.26,1.46,4.38c1,1.14,2.26,1.71,3.78,1.71c1.62,0,2.94-0.55,3.94-1.65c1-1.14,1.5-2.59,1.5-4.34 c0-1.76-0.5-3.2-1.5-4.34c-1-1.11-2.3-1.67-3.9-1.67c-1.51,0-2.77,0.56-3.78,1.69C48.9,66.13,48.4,67.54,48.4,69.22z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.0056,
    y1: 91.1707,
    x2: 77.0056,
    y2: 39.2706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.02,79.39c-0.08,0-0.35-0.01-0.83-0.04c-0.48-0.02-1.03-0.13-1.68-0.32c-0.64-0.19-1.32-0.48-2.04-0.88 c-0.72-0.4-1.39-0.97-2.01-1.72c-0.62-0.75-1.13-1.69-1.52-2.83c-0.4-1.14-0.6-2.54-0.6-4.22L68.33,60l4.7,0l0.01,10.04 c0,0.55,0.05,1.11,0.16,1.69c0.1,0.58,0.3,1.1,0.58,1.58c0.28,0.48,0.68,0.87,1.2,1.18c0.51,0.31,1.19,0.47,2.04,0.47 c0.85,0,1.53-0.16,2.04-0.47c0.51-0.31,0.91-0.71,1.19-1.18c0.28-0.48,0.47-1,0.58-1.58c0.1-0.58,0.15-1.14,0.15-1.69 l-0.01-10.04l4.7,0l0.01,9.38c0,1.68-0.2,3.08-0.59,4.22c-0.4,1.14-0.9,2.08-1.52,2.83c-0.62,0.75-1.28,1.33-2,1.73 c-0.72,0.4-1.4,0.7-2.04,0.88c-0.64,0.19-1.2,0.29-1.68,0.32C77.37,79.37,77.1,79.39,77.02,79.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.7912,
    y1: 91.1707,
    x2: 94.7912,
    y2: 39.2706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.46,64.44l0.01,8.37c0.08,0.3,0.22,0.58,0.42,0.83c0.18,0.2,0.43,0.39,0.75,0.56 c0.32,0.17,0.74,0.26,1.25,0.26l2.93,0l0,4.54l-4.7,0c-1-0.1-1.9-0.37-2.7-0.82c-0.67-0.37-1.28-0.93-1.83-1.67 c-0.55-0.74-0.83-1.76-0.83-3.06l-0.02-18.57l4.7,0l0.01,5.1l4.43,0l0,4.47L94.46,64.44z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.24,59.38h4.34v19.19h-4.34v-2.77c-1.41,2.12-3.85,3.11-5.99,3.11c-2.7,0-4.92-0.95-6.69-2.85 c-1.75-1.94-2.62-4.35-2.62-7.25c0-2.85,0.87-5.22,2.62-7.12c1.75-1.9,3.94-2.8,6.57-2.85c2.32-0.04,4.35,0.48,6.11,2.06V59.38z  M49.02,68.64c0,1.79,0.49,3.26,1.46,4.38c1,1.14,2.26,1.71,3.78,1.71c1.62,0,2.94-0.55,3.94-1.65c1-1.14,1.5-2.59,1.5-4.34 c0-1.76-0.5-3.2-1.5-4.34c-1-1.11-2.3-1.67-3.9-1.67c-1.51,0-2.77,0.56-3.78,1.69C49.52,65.55,49.02,66.96,49.02,68.64z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.64,78.81c-0.08,0-0.35-0.01-0.83-0.04c-0.48-0.02-1.03-0.13-1.68-0.32c-0.64-0.19-1.32-0.48-2.04-0.88 c-0.72-0.4-1.39-0.97-2.01-1.72c-0.62-0.75-1.13-1.69-1.52-2.83c-0.4-1.14-0.6-2.54-0.6-4.22l-0.01-9.38l4.7,0l0.01,10.04 c0,0.55,0.05,1.11,0.16,1.69c0.1,0.58,0.3,1.1,0.58,1.58c0.28,0.48,0.68,0.87,1.2,1.18c0.51,0.31,1.19,0.47,2.04,0.47 c0.85,0,1.53-0.16,2.04-0.47c0.51-0.31,0.91-0.71,1.19-1.18c0.28-0.48,0.47-1,0.58-1.58c0.1-0.58,0.15-1.14,0.15-1.69L81.59,59.4 l4.7,0l0.01,9.38c0,1.68-0.2,3.08-0.59,4.22c-0.4,1.14-0.9,2.08-1.52,2.83c-0.62,0.75-1.28,1.33-2,1.73 c-0.72,0.4-1.4,0.7-2.04,0.88c-0.64,0.19-1.2,0.29-1.68,0.32C78,78.79,77.72,78.81,77.64,78.81z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.08,63.86l0.01,8.37c0.08,0.3,0.22,0.58,0.42,0.83c0.18,0.2,0.43,0.39,0.75,0.56 c0.32,0.17,0.74,0.26,1.25,0.26l2.93,0l0,4.54l-4.7,0c-1-0.1-1.9-0.37-2.7-0.82c-0.67-0.37-1.28-0.93-1.83-1.67 c-0.55-0.74-0.83-1.76-0.83-3.06l-0.02-18.57l4.7,0l0.01,5.1l4.43,0l0,4.47L95.08,63.86z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.5102,
    y1: 94.3035,
    x2: 153.5102,
    y2: 55.4118,
    gradientTransform: "matrix(1 0 0 1 -103.4281 32.4716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.71,93.62c0-1.33,0.28-2.37,0.84-3.13c0.56-0.76,1.17-1.33,1.84-1.71c0.79-0.46,1.69-0.74,2.69-0.85 l5.38-0.01l0.01,4.65l-3.61,0.01c-0.51,0-0.93,0.09-1.25,0.27c-0.32,0.18-0.57,0.37-0.75,0.58c-0.2,0.26-0.34,0.54-0.42,0.85 l0.02,13.13l-4.72,0.01L44.71,93.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.1444,
    y1: 116.6696,
    x2: 66.1444,
    y2: 77.778
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M75.05,95.15c0.05,0.38,0.1,0.78,0.14,1.19c0.04,0.41,0.06,0.84,0.06,1.31l0,0.69l-13.44,0.02 c0.05,0.44,0.12,0.88,0.19,1.32c0.08,0.45,0.21,0.89,0.39,1.32c0.28,0.67,0.72,1.25,1.31,1.76c0.59,0.51,1.41,0.77,2.46,0.76 c1.05,0,1.87-0.26,2.46-0.77c0.59-0.51,1.02-1.1,1.3-1.77l4.99-0.01c-0.2,0.9-0.49,1.68-0.86,2.34 c-0.37,0.67-0.78,1.24-1.23,1.73c-0.45,0.49-0.93,0.89-1.44,1.21c-0.51,0.32-1.01,0.58-1.5,0.79c-1.18,0.46-2.42,0.69-3.72,0.7 c-1.72-0.02-3.24-0.38-4.57-1.07c-0.56-0.31-1.12-0.7-1.67-1.17c-0.55-0.47-1.04-1.07-1.46-1.78c-0.42-0.72-0.76-1.57-1.02-2.57 c-0.26-1-0.39-2.16-0.39-3.49c0-1.33,0.12-2.5,0.38-3.49c0.25-1,0.59-1.86,1.01-2.59c0.42-0.73,0.91-1.34,1.46-1.83 c0.55-0.49,1.11-0.88,1.67-1.19c1.33-0.72,2.85-1.1,4.57-1.16c1.41,0.05,2.73,0.34,3.96,0.88c0.51,0.23,1.03,0.53,1.56,0.9 c0.53,0.37,1.01,0.83,1.46,1.38c0.45,0.55,0.85,1.2,1.19,1.96C74.64,93.27,74.89,94.15,75.05,95.15z M70.21,95.16 c-0.13-0.41-0.29-0.82-0.48-1.23c-0.19-0.41-0.46-0.78-0.79-1.11c-0.33-0.33-0.73-0.59-1.19-0.79c-0.46-0.19-1-0.29-1.61-0.29 c-0.61,0-1.15,0.1-1.61,0.29c-0.46,0.19-0.86,0.46-1.19,0.79c-0.33,0.33-0.6,0.71-0.8,1.11c-0.2,0.41-0.36,0.82-0.46,1.23 L70.21,95.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.6606,
    y1: 94.3035,
    x2: 189.6606,
    y2: 55.4118,
    gradientTransform: "matrix(1 0 0 1 -103.4281 32.4716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.21,87.37c0.08,0,0.35,0.01,0.83,0.04c0.47,0.02,1.03,0.13,1.67,0.32c0.64,0.19,1.32,0.49,2.04,0.9 c0.72,0.41,1.38,1,2,1.76c0.62,0.77,1.12,1.73,1.52,2.9c0.4,1.16,0.6,2.6,0.6,4.32l0.02,9.71l-4.68,0.01l-0.02-9.71 c0-0.56-0.05-1.14-0.16-1.73c-0.1-0.59-0.3-1.13-0.58-1.61c-0.28-0.49-0.68-0.89-1.19-1.21c-0.51-0.32-1.19-0.48-2.04-0.48 c-0.84,0-1.52,0.16-2.03,0.48c-0.51,0.32-0.91,0.72-1.19,1.21c-0.28,0.49-0.47,1.02-0.57,1.61c-0.1,0.59-0.15,1.17-0.15,1.73 l0.02,9.71l-4.68,0.01l-0.02-9.71c0-1.71,0.19-3.15,0.59-4.32c0.39-1.17,0.9-2.13,1.51-2.9c0.61-0.77,1.28-1.36,1.99-1.77 c0.72-0.41,1.39-0.71,2.03-0.91c0.64-0.19,1.19-0.3,1.65-0.33C85.82,87.39,86.11,87.37,86.21,87.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.3476,
    y1: 94.3035,
    x2: 206.3476,
    y2: 55.4118,
    gradientTransform: "matrix(1 0 0 1 -103.4281 32.4716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.59,92.42l0.01,8.56c0.08,0.31,0.22,0.59,0.42,0.84c0.18,0.2,0.43,0.4,0.75,0.57 c0.32,0.18,0.74,0.27,1.25,0.27l2.92,0l0.01,4.65l-4.68,0.01c-1-0.1-1.9-0.38-2.69-0.84c-0.67-0.38-1.28-0.95-1.83-1.71 c-0.55-0.75-0.83-1.8-0.83-3.13l-0.03-19.01l4.68-0.01l0.01,5.22l4.42-0.01l0.01,4.57L102.59,92.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.9364,
    y1: 94.3035,
    x2: 237.9364,
    y2: 55.4118,
    gradientTransform: "matrix(1 0 0 1 -103.4281 32.4716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M136.83,81.34l0.04,25.92l-4.68,0.01l-0.04-25.92L136.83,81.34z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.3,93.02c0-1.33,0.28-2.37,0.84-3.13c0.56-0.76,1.17-1.33,1.84-1.71c0.79-0.46,1.69-0.74,2.69-0.85 l5.38-0.01l0.01,4.65l-3.61,0.01c-0.51,0-0.93,0.09-1.25,0.27c-0.32,0.18-0.57,0.37-0.75,0.58c-0.2,0.26-0.34,0.54-0.42,0.85 l0.02,13.13l-4.72,0.01L45.3,93.02z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.64,94.55c0.05,0.38,0.1,0.78,0.14,1.19c0.04,0.41,0.06,0.84,0.06,1.31l0,0.69L62.4,97.75 c0.05,0.44,0.12,0.88,0.19,1.32c0.08,0.45,0.21,0.89,0.39,1.32c0.28,0.67,0.72,1.25,1.31,1.76c0.59,0.51,1.41,0.77,2.46,0.76 c1.05,0,1.87-0.26,2.46-0.77c0.59-0.51,1.02-1.1,1.3-1.77l4.99-0.01c-0.2,0.9-0.49,1.68-0.86,2.34c-0.37,0.67-0.78,1.24-1.23,1.73 c-0.45,0.49-0.93,0.89-1.44,1.21c-0.51,0.32-1.01,0.58-1.5,0.79c-1.18,0.46-2.42,0.69-3.72,0.7c-1.72-0.02-3.24-0.38-4.57-1.07 c-0.56-0.31-1.12-0.7-1.67-1.17c-0.55-0.47-1.04-1.07-1.46-1.78c-0.42-0.72-0.76-1.57-1.02-2.57c-0.26-1-0.39-2.16-0.39-3.49 c0-1.33,0.12-2.5,0.38-3.49c0.25-1,0.59-1.86,1.01-2.59c0.42-0.73,0.91-1.34,1.46-1.83c0.55-0.49,1.11-0.88,1.67-1.19 c1.33-0.72,2.85-1.1,4.57-1.16c1.41,0.05,2.73,0.34,3.96,0.88c0.51,0.23,1.03,0.53,1.56,0.9c0.53,0.37,1.01,0.83,1.46,1.38 c0.45,0.55,0.85,1.2,1.19,1.96C75.24,92.67,75.49,93.55,75.64,94.55z M70.81,94.55c-0.13-0.41-0.29-0.82-0.48-1.23 c-0.19-0.41-0.46-0.78-0.79-1.11c-0.33-0.33-0.73-0.59-1.19-0.79c-0.46-0.19-1-0.29-1.61-0.29c-0.61,0-1.15,0.1-1.61,0.29 c-0.46,0.19-0.86,0.46-1.19,0.79c-0.33,0.33-0.6,0.71-0.8,1.11c-0.2,0.41-0.36,0.82-0.46,1.23L70.81,94.55z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.81,86.77c0.08,0,0.35,0.01,0.83,0.04c0.47,0.02,1.03,0.13,1.67,0.32c0.64,0.19,1.32,0.49,2.04,0.9 c0.72,0.41,1.38,1,2,1.76c0.62,0.77,1.12,1.73,1.52,2.9c0.4,1.16,0.6,2.6,0.6,4.32l0.02,9.71l-4.68,0.01l-0.02-9.71 c0-0.56-0.05-1.14-0.16-1.73c-0.1-0.59-0.3-1.13-0.58-1.61c-0.28-0.49-0.68-0.89-1.19-1.21c-0.51-0.32-1.19-0.48-2.04-0.48 c-0.84,0-1.52,0.16-2.03,0.48c-0.51,0.32-0.91,0.72-1.19,1.21c-0.28,0.49-0.47,1.02-0.57,1.61c-0.1,0.59-0.15,1.17-0.15,1.73 l0.02,9.71l-4.68,0.01l-0.02-9.71c0-1.71,0.19-3.15,0.59-4.32c0.39-1.17,0.9-2.13,1.51-2.9c0.61-0.77,1.28-1.36,1.99-1.77 c0.72-0.41,1.39-0.71,2.03-0.91c0.64-0.19,1.19-0.3,1.65-0.33C86.42,86.79,86.7,86.77,86.81,86.77z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.19,91.82l0.01,8.56c0.08,0.31,0.22,0.59,0.42,0.84c0.18,0.2,0.43,0.4,0.75,0.57 c0.32,0.18,0.74,0.27,1.25,0.27l2.92,0l0.01,4.65l-4.68,0.01c-1-0.1-1.9-0.38-2.69-0.84c-0.67-0.38-1.28-0.95-1.83-1.71 c-0.55-0.75-0.83-1.8-0.83-3.13l-0.03-19.01l4.68-0.01l0.01,5.22l4.42-0.01l0.01,4.57L103.19,91.82z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M137.43,80.74l0.04,25.92l-4.68,0.01l-0.04-25.92L137.43,80.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.2114,
    y1: 119.2453,
    x2: 119.2114,
    y2: 67.3452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3379,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#8F898E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#AAA5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9249,
    style: {
      stopColor: "#CEC9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4E1DF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M124.69,88.04h4.34v19.19h-4.34v-2.77c-1.41,2.12-3.85,3.11-5.99,3.11c-2.7,0-4.92-0.95-6.69-2.85 c-1.75-1.94-2.62-4.35-2.62-7.25c0-2.85,0.87-5.22,2.62-7.12c1.75-1.9,3.94-2.8,6.57-2.85c2.32-0.04,4.35,0.48,6.11,2.06V88.04 z M113.47,97.3c0,1.79,0.49,3.26,1.46,4.38c1,1.14,2.26,1.71,3.78,1.71c1.62,0,2.94-0.55,3.94-1.65c1-1.14,1.5-2.59,1.5-4.34 c0-1.76-0.5-3.2-1.5-4.34c-1-1.11-2.3-1.67-3.9-1.67c-1.51,0-2.77,0.56-3.78,1.69C113.97,94.21,113.47,95.62,113.47,97.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M125.31,87.46h4.34v19.19h-4.34v-2.77c-1.41,2.12-3.85,3.11-5.99,3.11c-2.7,0-4.92-0.95-6.69-2.85 c-1.75-1.94-2.62-4.35-2.62-7.25c0-2.85,0.87-5.22,2.62-7.12c1.75-1.9,3.94-2.8,6.57-2.85c2.32-0.04,4.35,0.48,6.11,2.06V87.46z  M114.09,96.72c0,1.79,0.49,3.26,1.46,4.38c1,1.14,2.26,1.71,3.78,1.71c1.62,0,2.94-0.55,3.94-1.65c1-1.14,1.5-2.59,1.5-4.34 c0-1.76-0.5-3.2-1.5-4.34c-1-1.11-2.3-1.67-3.9-1.67c-1.51,0-2.77,0.56-3.78,1.69C114.59,93.63,114.09,95.04,114.09,96.72z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 115.68,
    y1: 55.69,
    x2: 115.67,
    y2: 55.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 107.56,
    y1: 57.44,
    x2: 107.55,
    y2: 57.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.3901,
    y1: 55.7258,
    x2: 122.5914,
    y2: 55.7258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5B5B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1236,
    style: {
      stopColor: "#676565"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2382,
    style: {
      stopColor: "#959393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3346,
    style: {
      stopColor: "#BFBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#D2D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    style: {
      stopColor: "#736F73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7806,
    style: {
      stopColor: "#827E80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8446,
    style: {
      stopColor: "#A09D9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9327,
    style: {
      stopColor: "#BBB9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CDCCCC"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122.16,64.67c-0.29-1.05-0.66-1.96-1.11-2.73c-0.45-0.77-0.97-1.41-1.56-1.92 c-0.59-0.51-1.18-0.93-1.78-1.25c-0.66-0.35-1.37-0.63-2.12-0.83l-1.02-1.78l0,0c-0.95-1.66-2.21-3.59-3.68-5.51 c-1.27-1.73-2.77-3.44-4.49-5.09c-0.01-0.01-0.01-0.01-0.02-0.02c-5.29-5.07-12.15-9.1-19.29-11.37l0,0 c-0.22-0.07-0.45-0.14-0.68-0.21c-0.06-0.02-0.12-0.04-0.19-0.06c-0.2-0.06-0.41-0.12-0.61-0.18c-0.04-0.01-0.07-0.02-0.11-0.03 c-0.24-0.07-0.48-0.13-0.73-0.2c-0.06-0.02-0.13-0.03-0.19-0.05c-0.21-0.05-0.41-0.11-0.62-0.16c-0.06-0.01-0.11-0.03-0.17-0.04 c-0.26-0.06-0.52-0.12-0.78-0.18c-0.06-0.01-0.12-0.02-0.17-0.04c-0.22-0.05-0.44-0.09-0.67-0.14c-0.07-0.01-0.14-0.03-0.21-0.04 c-0.28-0.05-0.55-0.11-0.84-0.16c-0.04-0.01-0.08-0.01-0.12-0.02c-0.25-0.04-0.5-0.09-0.75-0.13c-0.08-0.01-0.16-0.02-0.24-0.04 c-0.29-0.04-0.58-0.09-0.87-0.13c-0.01,0-0.01,0-0.02,0c-0.3-0.04-0.6-0.08-0.91-0.11c-0.08-0.01-0.16-0.02-0.25-0.03 c-0.26-0.03-0.53-0.06-0.8-0.08c-0.05,0-0.1-0.01-0.15-0.01c-0.31-0.03-0.63-0.05-0.95-0.07c-0.08-0.01-0.16-0.01-0.24-0.02 c-0.26-0.02-0.53-0.03-0.79-0.04c-0.07,0-0.15-0.01-0.22-0.01c-0.33-0.01-0.65-0.02-0.99-0.03c-0.07,0-0.14,0-0.21,0 c-0.27,0-0.55-0.01-0.83,0c-0.09,0-0.18,0-0.26,0c-0.34,0-0.68,0.01-1.03,0.02c-0.05,0-0.09,0-0.14,0.01 c-0.3,0.01-0.61,0.02-0.92,0.04c-0.09,0.01-0.19,0.01-0.28,0.02c-0.34,0.02-0.68,0.04-1.03,0.07c-0.01,0-0.03,0-0.04,0 c-0.36,0.03-0.72,0.07-1.08,0.11c-0.1,0.01-0.2,0.02-0.29,0.03c-0.31,0.04-0.62,0.08-0.93,0.12c-0.06,0.01-0.13,0.02-0.19,0.03 c-0.37,0.05-0.73,0.11-1.1,0.17c-0.09,0.02-0.19,0.03-0.28,0.05c-0.3,0.05-0.61,0.11-0.92,0.17c-0.09,0.02-0.17,0.03-0.26,0.05 c-0.37,0.08-0.75,0.16-1.13,0.24c-0.08,0.02-0.16,0.04-0.24,0.06c-0.31,0.07-0.63,0.15-0.95,0.23c-0.1,0.03-0.2,0.05-0.3,0.08 c-0.38,0.1-0.77,0.21-1.16,0.32c-0.05,0.01-0.1,0.03-0.15,0.05c-0.35,0.1-0.69,0.21-1.04,0.32c-0.11,0.03-0.21,0.07-0.32,0.1 c-0.38,0.12-0.75,0.25-1.13,0.38c-0.02,0.01-0.04,0.01-0.07,0.02c-0.4,0.14-0.8,0.29-1.2,0.45c-0.11,0.04-0.21,0.08-0.32,0.13 c-0.34,0.13-0.68,0.27-1.02,0.42c-0.07,0.03-0.14,0.06-0.22,0.09c-0.4,0.17-0.8,0.35-1.21,0.54c-0.1,0.05-0.2,0.09-0.3,0.14 c-0.33,0.16-0.66,0.32-1,0.48c-0.1,0.05-0.19,0.09-0.29,0.14c-0.41,0.2-0.81,0.42-1.22,0.63c-0.02,0.01-0.05,0.02-0.07,0.04 c0.01,0,0.02-0.01,0.03-0.01c-5.74,3.08-11.68,7.64-17.58,14.22c-3.7,0.53-11.93,2.4-16.91,8.86c-3.21,4.16-4.42,9.34-3.59,15.39 c0.29,2.1,2.17,3.57,4.23,3.3c0.02,0,0.04,0,0.06-0.01c2.07-0.3,3.52-2.25,3.23-4.37c-0.54-3.94,0.13-7.05,2.04-9.53 c3.89-5.05,11.91-5.98,12.8-6.08c1.19-0.12,2.26-0.66,3.02-1.53c7.57-8.67,15.86-14.33,24.63-16.81 c7.31-2.07,14.78-1.93,22.19,0.43v0c11.32,3.77,17.32,10.15,21.08,15.4l1.26,1.84c-0.38,0.25-3.55,2.55-3.94,7.75 c-0.09,0.82-0.13,1.86-0.02,3.08c0.06,0.89,0.18,1.7,0.37,2.42c0.27,1.05,0.64,1.96,1.09,2.71c0.45,0.76,0.97,1.38,1.56,1.88 c0.59,0.5,1.18,0.91,1.78,1.23c1.42,0.73,3.05,1.1,4.88,1.13c1.8-0.03,3.41-0.41,4.83-1.14c0.6-0.32,1.19-0.74,1.78-1.24 c0.59-0.5,1.11-1.13,1.55-1.88c0.45-0.76,0.82-1.66,1.1-2.71c0.29-1.05,0.43-2.28,0.43-3.69 C122.59,66.95,122.45,65.72,122.16,64.67z M116.93,72.97c-1.05,1.21-2.44,1.82-4.15,1.82c-1.6,0-2.93-0.63-3.98-1.89 c-1.03-1.24-1.54-2.85-1.54-4.83c0-1.85,0.53-3.4,1.58-4.66c1.07-1.24,2.4-1.86,3.98-1.86c1.68,0,3.05,0.61,4.11,1.84 c1.05,1.26,1.58,2.85,1.58,4.79C118.51,70.12,117.98,71.71,116.93,72.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.608,
    y1: 40.1065,
    x2: 121.6242,
    y2: 76.5927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0557,
    style: {
      stopColor: "#828081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0565,
    style: {
      stopColor: "#828181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2119,
    style: {
      stopColor: "#B6B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3257,
    style: {
      stopColor: "#DDDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3849,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4108,
    style: {
      stopColor: "#E7E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5964,
    style: {
      stopColor: "#B8B4B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6872,
    style: {
      stopColor: "#A8A3A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#AFAAAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7695,
    style: {
      stopColor: "#D0CBC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8056,
    style: {
      stopColor: "#DDD9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    style: {
      stopColor: "#BBB6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9159,
    style: {
      stopColor: "#A29C9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9646,
    style: {
      stopColor: "#948E93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F898E"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.54,64.47c-0.29-1.06-0.67-1.98-1.12-2.76c-0.46-0.78-0.98-1.42-1.58-1.94 c-0.6-0.52-1.2-0.94-1.81-1.26c-0.55-0.29-1.12-0.53-1.72-0.71l-1.64-2.81l0,0c-0.98-1.67-2.27-3.6-3.78-5.54 c-1.3-1.74-2.84-3.46-4.61-5.11c-0.01-0.01-0.01-0.01-0.02-0.02c-5.43-5.09-12.46-9.15-19.78-11.42c0,0,0,0,0,0 c-0.23-0.07-0.46-0.14-0.7-0.21c-0.06-0.02-0.13-0.04-0.19-0.06c-0.21-0.06-0.42-0.12-0.63-0.18c-0.04-0.01-0.08-0.02-0.12-0.03 c-0.25-0.07-0.5-0.13-0.75-0.2c-0.06-0.02-0.13-0.03-0.19-0.05c-0.21-0.05-0.42-0.11-0.64-0.16c-0.06-0.01-0.12-0.03-0.18-0.04 c-0.26-0.06-0.53-0.12-0.8-0.18c-0.06-0.01-0.12-0.03-0.18-0.04c-0.23-0.05-0.46-0.1-0.69-0.14c-0.07-0.01-0.14-0.03-0.21-0.04 c-0.28-0.05-0.57-0.11-0.86-0.16c-0.04-0.01-0.08-0.01-0.13-0.02c-0.25-0.04-0.51-0.09-0.77-0.13c-0.08-0.01-0.16-0.03-0.24-0.04 c-0.3-0.04-0.59-0.09-0.9-0.13c-0.01,0-0.01,0-0.02,0c-0.31-0.04-0.62-0.08-0.93-0.11c-0.08-0.01-0.17-0.02-0.25-0.03 c-0.27-0.03-0.54-0.06-0.82-0.08c-0.05,0-0.1-0.01-0.15-0.01c-0.32-0.03-0.64-0.05-0.97-0.07c-0.08-0.01-0.16-0.01-0.25-0.02 c-0.27-0.02-0.54-0.03-0.81-0.04c-0.08,0-0.15-0.01-0.23-0.01c-0.33-0.01-0.67-0.02-1.01-0.03c-0.07,0-0.14,0-0.22,0 c-0.28,0-0.57-0.01-0.85,0c-0.09,0-0.18,0-0.27,0c-0.35,0-0.7,0.01-1.05,0.02c-0.05,0-0.1,0-0.14,0.01 c-0.31,0.01-0.63,0.02-0.94,0.04c-0.1,0.01-0.19,0.01-0.29,0.02c-0.35,0.02-0.7,0.05-1.06,0.07c-0.01,0-0.03,0-0.04,0 c-0.37,0.03-0.74,0.07-1.11,0.11c-0.1,0.01-0.2,0.02-0.3,0.03c-0.32,0.04-0.63,0.08-0.95,0.12c-0.06,0.01-0.13,0.02-0.19,0.03 c-0.37,0.05-0.75,0.11-1.13,0.17c-0.09,0.02-0.19,0.03-0.29,0.05c-0.31,0.05-0.63,0.11-0.94,0.17c-0.09,0.02-0.18,0.03-0.27,0.05 c-0.38,0.08-0.77,0.16-1.16,0.24c-0.08,0.02-0.16,0.04-0.25,0.06c-0.32,0.07-0.65,0.15-0.97,0.23c-0.1,0.03-0.21,0.05-0.31,0.08 c-0.39,0.1-0.79,0.21-1.19,0.32c-0.05,0.01-0.1,0.03-0.15,0.05c-0.35,0.1-0.71,0.21-1.07,0.32c-0.11,0.03-0.22,0.07-0.33,0.1 c-0.38,0.12-0.77,0.25-1.16,0.39c-0.02,0.01-0.04,0.02-0.07,0.02c-0.41,0.14-0.82,0.29-1.23,0.45c-0.11,0.04-0.22,0.08-0.33,0.13 c-0.35,0.13-0.7,0.27-1.04,0.42c-0.07,0.03-0.15,0.06-0.22,0.09c-0.41,0.17-0.82,0.35-1.24,0.54c-0.1,0.05-0.21,0.09-0.31,0.14 c-0.34,0.16-0.68,0.32-1.02,0.48c-0.1,0.05-0.2,0.09-0.29,0.14c-0.42,0.21-0.84,0.42-1.25,0.64c-0.02,0.01-0.05,0.02-0.07,0.04 c0.01,0,0.02-0.01,0.03-0.01c-5.89,3.1-11.98,7.68-18.03,14.29c-3.8,0.53-12.23,2.41-17.34,8.9c-3.29,4.18-4.53,9.39-3.68,15.47 c0.3,2.11,2.23,3.58,4.33,3.32c0.02,0,0.04,0,0.06-0.01c2.13-0.3,3.61-2.26,3.31-4.39c-0.55-3.96,0.13-7.09,2.09-9.58 c3.99-5.07,12.21-6.01,13.13-6.1c1.22-0.12,2.32-0.66,3.1-1.53c7.76-8.71,16.26-14.4,25.26-16.9c7.5-2.08,15.15-1.94,22.76,0.43 v0c11.61,3.79,17.76,10.19,21.61,15.48l2.05,2.92c-0.48,0.29-0.96,0.64-1.44,1.06c-0.59,0.52-1.12,1.16-1.57,1.94 c-0.46,0.78-0.82,1.7-1.1,2.76c-0.28,1.06-0.41,2.3-0.41,3.72c0,1.42,0.14,2.65,0.42,3.72c0.28,1.06,0.65,1.97,1.1,2.73 c0.46,0.76,0.98,1.39,1.58,1.9c0.6,0.5,1.2,0.92,1.81,1.24c1.44,0.73,3.08,1.11,4.94,1.14c1.83-0.03,3.46-0.41,4.89-1.15 c0.61-0.33,1.21-0.74,1.8-1.25c0.59-0.5,1.12-1.14,1.57-1.9c0.46-0.76,0.83-1.68,1.12-2.74c0.29-1.06,0.43-2.3,0.43-3.72 C123.98,66.77,123.83,65.53,123.54,64.47z M118.11,72.67c-1.03,1.18-2.38,1.77-4.06,1.77c-1.57,0-2.87-0.61-3.9-1.84 c-1-1.21-1.51-2.78-1.51-4.7c0-1.8,0.52-3.32,1.55-4.54c1.04-1.21,2.34-1.82,3.9-1.82c1.65,0,2.99,0.6,4.02,1.8 c1.03,1.22,1.55,2.78,1.55,4.66C119.65,69.89,119.14,71.45,118.11,72.67z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 90.1617,
    cy: 37.3296,
    r: 57.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0492,
    style: {
      stopColor: "#DEDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2466,
    style: {
      stopColor: "#8B8888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    style: {
      stopColor: "#565453"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    style: {
      stopColor: "#353332"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7675,
    style: {
      stopColor: "#1C1C1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M123.54,64.47c-0.29-1.06-0.67-1.98-1.12-2.76c-0.46-0.78-0.98-1.42-1.58-1.94 c-0.6-0.52-1.2-0.94-1.81-1.26c-0.55-0.29-1.12-0.53-1.72-0.71l-1.64-2.81l0,0c-0.98-1.67-2.27-3.6-3.78-5.54 c-1.3-1.74-2.84-3.46-4.61-5.11c-0.01-0.01-0.01-0.01-0.02-0.02c-5.43-5.09-12.46-9.15-19.78-11.42c0,0,0,0,0,0 c-0.23-0.07-0.46-0.14-0.7-0.21c-0.06-0.02-0.13-0.04-0.19-0.06c-0.21-0.06-0.42-0.12-0.63-0.18c-0.04-0.01-0.08-0.02-0.12-0.03 c-0.25-0.07-0.5-0.13-0.75-0.2c-0.06-0.02-0.13-0.03-0.19-0.05c-0.21-0.05-0.42-0.11-0.64-0.16c-0.06-0.01-0.12-0.03-0.18-0.04 c-0.26-0.06-0.53-0.12-0.8-0.18c-0.06-0.01-0.12-0.03-0.18-0.04c-0.23-0.05-0.46-0.1-0.69-0.14c-0.07-0.01-0.14-0.03-0.21-0.04 c-0.28-0.05-0.57-0.11-0.86-0.16c-0.04-0.01-0.08-0.01-0.13-0.02c-0.25-0.04-0.51-0.09-0.77-0.13c-0.08-0.01-0.16-0.03-0.24-0.04 c-0.3-0.04-0.59-0.09-0.9-0.13c-0.01,0-0.01,0-0.02,0c-0.31-0.04-0.62-0.08-0.93-0.11c-0.08-0.01-0.17-0.02-0.25-0.03 c-0.27-0.03-0.54-0.06-0.82-0.08c-0.05,0-0.1-0.01-0.15-0.01c-0.32-0.03-0.64-0.05-0.97-0.07c-0.08-0.01-0.16-0.01-0.25-0.02 c-0.27-0.02-0.54-0.03-0.81-0.04c-0.08,0-0.15-0.01-0.23-0.01c-0.33-0.01-0.67-0.02-1.01-0.03c-0.07,0-0.14,0-0.22,0 c-0.28,0-0.57-0.01-0.85,0c-0.09,0-0.18,0-0.27,0c-0.35,0-0.7,0.01-1.05,0.02c-0.05,0-0.1,0-0.14,0.01 c-0.31,0.01-0.63,0.02-0.94,0.04c-0.1,0.01-0.19,0.01-0.29,0.02c-0.35,0.02-0.7,0.05-1.06,0.07c-0.01,0-0.03,0-0.04,0 c-0.37,0.03-0.74,0.07-1.11,0.11c-0.1,0.01-0.2,0.02-0.3,0.03c-0.32,0.04-0.63,0.08-0.95,0.12c-0.06,0.01-0.13,0.02-0.19,0.03 c-0.37,0.05-0.75,0.11-1.13,0.17c-0.09,0.02-0.19,0.03-0.29,0.05c-0.31,0.05-0.63,0.11-0.94,0.17c-0.09,0.02-0.18,0.03-0.27,0.05 c-0.38,0.08-0.77,0.16-1.16,0.24c-0.08,0.02-0.16,0.04-0.25,0.06c-0.25,0.06-0.51,0.12-0.77,0.18 c7.11-0.18,16.01,1.49,24.12,8.48C97,44.35,103,50.62,106.79,55.81l2.05,2.92c-0.48,0.29-0.96,0.64-1.44,1.06 c-0.59,0.52-1.12,1.16-1.57,1.94c-0.46,0.78-0.82,1.7-1.1,2.76c-0.28,1.06-0.41,2.3-0.41,3.72c0,1.42,0.14,2.65,0.42,3.72 c0.28,1.06,0.65,1.97,1.1,2.73c0.46,0.76,0.98,1.39,1.58,1.9c0.6,0.5,1.2,0.92,1.81,1.24c1.44,0.73,3.08,1.11,4.94,1.14 c1.83-0.03,3.46-0.41,4.89-1.15c0.61-0.33,1.21-0.74,1.8-1.25c0.59-0.5,1.12-1.14,1.57-1.9c0.46-0.76,0.83-1.68,1.12-2.74 c0.29-1.06,0.43-2.3,0.43-3.72C123.98,66.77,123.83,65.53,123.54,64.47z M118.11,72.67c-1.03,1.18-2.38,1.77-4.06,1.77 c-1.57,0-2.87-0.61-3.9-1.84c-1-1.21-1.51-2.78-1.51-4.7c0-1.8,0.52-3.32,1.55-4.54c1.04-1.21,2.34-1.82,3.9-1.82 c1.65,0,2.99,0.6,4.02,1.8c1.03,1.22,1.55,2.78,1.55,4.66C119.65,69.89,119.14,71.45,118.11,72.67z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.64,106.51c0.01-0.24,0.03-0.59,0.03-0.9v-4.2h0.63v2.18h0.01c0.22-0.39,0.63-0.64,1.19-0.64 c0.86,0,1.47,0.72,1.47,1.78c0,1.24-0.78,1.86-1.56,1.86c-0.5,0-0.91-0.19-1.16-0.65h-0.02l-0.03,0.57H140.64z M141.29,105.11 c0,0.08,0.01,0.16,0.03,0.23c0.12,0.44,0.49,0.74,0.95,0.74c0.66,0,1.06-0.54,1.06-1.34c0-0.7-0.36-1.29-1.03-1.29 c-0.43,0-0.83,0.29-0.96,0.78c-0.01,0.07-0.04,0.16-0.04,0.26V105.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.94,103.03l0.76,2.05c0.08,0.23,0.17,0.5,0.22,0.71h0.01c0.06-0.21,0.14-0.47,0.22-0.73l0.69-2.04h0.67 l-0.95,2.48c-0.45,1.19-0.76,1.8-1.19,2.18c-0.31,0.27-0.62,0.38-0.78,0.41l-0.16-0.53c0.16-0.05,0.37-0.15,0.55-0.31 c0.17-0.14,0.39-0.38,0.53-0.7c0.03-0.06,0.05-0.11,0.05-0.15c0-0.04-0.01-0.09-0.04-0.17l-1.29-3.2H144.94z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAuto);
export default __webpack_public_path__ + "static/media/logo-auto.3ced404699fc75d99c8d9a47bdf685f5.svg";
export { ForwardRef as ReactComponent };